export default "__VITE_ASSET__d79fee12__"